import React from "react";
import NavLogo from "../../../Assets/Image/png/Vector.png";
import { BtnAlternative, BtnPrimary } from "../buttons/Btn";
import { Link, useMatch, useResolvedPath } from "react-router-dom";
import IconBtnNoTooltip from "../../share/buttons/IconBtnNoTooltip";

const Sidebar = ({ menu, type, scroll }) => {
    return (
        <div
            className={
                scroll
                    ? "h-full bg-white-dark shadow-nav top-0 right-0 w-[20vw]"
                    : "h-full bg-white-dark shadow-nav fixed top-0 right-0 w-[20vw]"
            }
        >
            <div className=" px-10 pt-10 pb-24 flex flex-col relative h-full">
                <Link to="/dashboard">
                    <div className="flex items-center justify-center mb-6 self-center">
                        <img src={NavLogo} />
                        <h2 className="text-[2rem] leading-9">BootWeb</h2>
                    </div>
                </Link>
                {type === "admin" && (
                    <Link to="/create">
                        <BtnPrimary
                            text="+ ایجاد بوت کمپ جدید"
                            className="w-full px-12 py-8 mt-6 mb-8"
                        />
                    </Link>
                )}

                <ul className="Sidebar">
                    {menu.map((item, id) => (
                        <CustomLink to={item.link} key={id} className=" flex">
                            <li className="p-5 flex items-center ">
                                <IconBtnNoTooltip className="w-[2.4rem] text-purple-dark ml-[1.2rem] text-[2.4rem]">
                                    {item.icon}
                                </IconBtnNoTooltip>
                                <p className="text-primary-dark text-xs leading-[2.4rem]">
                                    {item.title}
                                </p>
                            </li>
                        </CustomLink>
                    ))}
                </ul>
                <BtnAlternative
                    text="خروج"
                    className="py-5 px-8 text-center self-center absolute bottom-[1.7rem]"
                    exit
                />
            </div>
        </div>
    );
};

export default Sidebar;

function CustomLink({ children, to, ...props }) {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });

    return (
        <div>
            <Link
                style={{
                    background: match ? "#9C5FA436" : "none",
                    borderRadius: match ? "1.5rem" : "none",
                }}
                to={to}
                {...props}
            >
                {children}
            </Link>
        </div>
    );
}
